import ButtonGipInfo from "./ButtonGipInfo";

export default ButtonGipInfo